import type { Block } from '@w/content-blocks'
import { createElement } from 'react'
import { useTranslation } from '../../i18n'
import type { BlockView } from '../view-api'
import { ClozeView } from './cloze'
import { PageLinkView, PageMetaView, PageTitleView } from './page'
import { CodeView, MathView, MediaView } from './presentation'
import { QuestionView } from './question'
import { LanguageView, EmphasisView } from './language'
import { AlertView, ColumnsView, ColumnView, ParagraphView, QuoteView, QuestionGroupView, RuleView, TableView, TableRowView, TableCellView } from './structure'

export { BlockViewProvider, type BlockViewServices } from './services'
export { convertQuestionSubtype, switchableQuestionSubtypes, type SwitchableQuestionSubtype } from './question-subtype'

const views: Partial<Record<Block['type'], BlockView>> = {
  p: ParagraphView,
  pageTitle: PageTitleView,
  pageMeta: PageMetaView,
  page: PageLinkView,
  pageLink: PageLinkView,
  pages: PageLinkView,
  mention: PageLinkView,
  l: LanguageView,
  em: EmphasisView,
  question: QuestionView,
  cloze: ClozeView,
  alert: AlertView,
  quote: QuoteView,
  rule: RuleView,
  questionGroup: QuestionGroupView,
  cols: ColumnsView,
  col: ColumnView,
  pre: CodeView,
  code: MathView,
  img: MediaView,
  video: MediaView,
  audio: MediaView,
  file: MediaView,
  preview: MediaView,
  table: TableView,
  tr: TableRowView,
  td: TableCellView,
}

/** Each registered view subscribes to locale changes, including the library's async English defaults. */
function localized(View: BlockView): BlockView {
  return function LocalizedBlockView(props) {
    const { t } = useTranslation()
    return createElement(View, { ...props, api: { ...props.api, t } })
  }
}

export const blockViews: Partial<Record<Block['type'], BlockView>> = Object.fromEntries(
  Object.entries(views).map(([type, View]) => [type, localized(View)]),
)
